module.exports = __webpack_public_path__ + "static/media/happy-boy.9f42726d.svg";